/* QUELL — product-main: PDP gallery / lightbox / variants / read-more. Split from theme.js. */
(function () {
  "use strict";
  function ready(fn) {
    if (document.readyState === "loading")
      document.addEventListener("DOMContentLoaded", fn);
    else fn();
  }

  /* ── Product main — PDP gallery / lightbox / variants / read-more ──
     Moved from sections/product-main.liquid. `scope` is the section root
     (the .shopify-section wrapper), passed in instead of the old inline
     document.currentScript lookup so it works from this external file. */
  function initProductMain(scope) {
    if (!scope) return;
    var thumbs = scope.querySelector("#thumbs");
    var mainImg = scope.querySelector("#mainImg");
    var mainShot = scope.querySelector("#mainShot");
    // Reassigned once the thumbnail-nav arrows are wired; applyGallery re-runs it after
    // a variant swap changes the strip. No-op default so it's always safe to call.
    var syncThumbNav = function () {};

    var setMainImage = function (url, minCue) {
      if (!mainImg) return;
      // Empty URL — variant has no dedicated image. Swap the current <img> back
      // to an empty <div class="main-empty"> placeholder frame so the user
      // doesn't see a broken/stale image (and JS doesn't wait forever for a
      // load event that will never fire).
      if (!url) {
        if (mainShot) mainShot.classList.remove("is-loading");
        if (
          mainImg.tagName !== "DIV" ||
          !mainImg.classList.contains("main-empty")
        ) {
          var empty = document.createElement("div");
          empty.id = "mainImg";
          empty.className = "main-empty";
          empty.setAttribute("role", "img");
          mainImg.parentNode.replaceChild(empty, mainImg);
          mainImg = empty;
        }
        return;
      }
      // We have a URL. If the current element is the empty placeholder <div>,
      // swap it back to an <img> so setting .src actually renders the image.
      if (mainImg.tagName !== "IMG") {
        var newImg = document.createElement("img");
        newImg.id = "mainImg";
        newImg.width = 1100;
        newImg.height = 1155;
        newImg.setAttribute("fetchpriority", "high");
        newImg.setAttribute("decoding", "async");
        mainImg.parentNode.replaceChild(newImg, mainImg);
        mainImg = newImg;
      }
      // Flip is-roomset only when the new image paints (applyFit), else the still-visible old slide gets the new fit.
      var nextRoomset = /\.jpe?g(\?|$)/i.test(url);
      var applyFit = function () {
        if (mainShot) mainShot.classList.toggle("is-roomset", nextRoomset);
      };
      // No loading state on the shot — the client asked for the swap to look
      // instant, never a dim + spinner. Set the src and let the browser hold
      // the previous frame until the new one is ready (warmAllVariants
      // prefetches every variant's hero so the swap is usually memory-cached
      // and the change reads as instant). applyFit still runs on load so a
      // scene→cutout transition flips the plate at the right moment.
      mainImg.addEventListener("load", applyFit, { once: true });
      mainImg.src = url;
      if (mainImg.complete) applyFit();
      // Legacy: any stale is-loading from an earlier version of this code
      // should not linger over the fresh image.
      if (mainShot) mainShot.classList.remove("is-loading");
      if (mainShot) {
        mainShot.classList.remove("imgfail");
      }
    };

    // Preload the strip's full-size hero images (data-img, 1100w) so the hero swaps
    // instantly on thumbnail click / prev-next — no per-press network wait. Runs on
    // init and after each variant re-render (applyGallery). Function scope so both reach it.
    //
    // The WHOLE strip, not the first three. Every data-img goes through the cut-out
    // proxy, which transforms on demand: measured 2026-10-12 on omni-demi, the three
    // images this used to warm answered HIT in 0.5–1.1s while images 4–7 answered MISS
    // in 1.7–2.2s on click — the "some swap instantly, some pause" report. The cap of
    // three dated from strips of ~10MB; at 1100w WebP an image is 38–113KB (~525KB for
    // all seven), so warming the lot is cheap.
    //
    // What still keeps it off the visible hero (the reason the cap existed): it waits
    // for the hero to load, starts at idle, runs low priority and PREWARM_CONCURRENCY
    // at a time, nearest the active image first so the next press is always warm
    // first. A variant swap bumps prewarmGen and the old variant's queue stops.
    // Save-Data warms the two neighbours only.
    var PREWARM_CONCURRENCY = 2;
    var PREWARM_MAX = 8;
    var prewarmed = {}; // url -> Image; held so nothing is fetched twice
    var prewarmGen = 0;
    var isR2Url = function (url) {
      return url && url.indexOf("images.quellworkspaces.com") !== -1;
    };
    var warmUrl = function (url, priority, done) {
      if (!url || prewarmed[url] || isR2Url(url)) {
        if (done) done();
        return;
      }
      var p = new Image();
      try {
        p.fetchPriority = priority;
      } catch (e) {}
      if (done) {
        p.onload = p.onerror = function () {
          done();
        };
      }
      prewarmed[url] = p;
      p.src = url;
    };
    // Outward from the active image: i+1, i-1, i+2, i-2 … (the strip loops).
    var prewarmOrder = function (urls, from) {
      var n = urls.length;
      var out = [];
      var seen = {};
      seen[urls[from]] = true; // already on screen
      var add = function (i) {
        var u = urls[i];
        if (u && !seen[u]) {
          seen[u] = true;
          out.push(u);
        }
      };
      for (var d = 1; d <= n / 2; d++) {
        add((from + d) % n);
        add((from - d + n) % n);
      }
      return out.slice(0, PREWARM_MAX);
    };
    var prewarmThumbs = function () {
      if (!thumbs) return;
      var gen = ++prewarmGen;
      var run = function () {
        if (gen !== prewarmGen) return;
        // Every button, not just [data-img], so indices line up with galIndex.
        var urls = [].map.call(thumbs.querySelectorAll("button"), function (b) {
          return b.getAttribute("data-img") || "";
        });
        if (!urls.length) return;
        var queue = prewarmOrder(urls, Math.min(galIndex, urls.length - 1));
        var conn = navigator.connection;
        if (conn && conn.saveData) queue = queue.slice(0, 2);
        var next = function () {
          if (gen !== prewarmGen || !queue.length) return;
          warmUrl(queue.shift(), "low", next);
        };
        for (var k = 0; k < PREWARM_CONCURRENCY; k++) next();
      };
      var schedule = function () {
        if ("requestIdleCallback" in window)
          requestIdleCallback(run, { timeout: 1500 });
        else setTimeout(run, 300);
      };
      // Hold the strip prewarm until the visible hero (thumb index 0) has finished
      // loading. The main image must always paint first and never wait behind the
      // rest of the gallery — so we warm the next few only once the hero is done.
      if (mainImg && !mainImg.complete) {
        mainImg.addEventListener("load", schedule, { once: true });
        mainImg.addEventListener("error", schedule, { once: true });
      } else {
        schedule();
      }
    };

    // Active thumbnail index. The strip keeps its natural order; the selection
    // (.on + hero) moves ALONG it, and the strip scrolls to keep the active thumb
    // in view — standard gallery UX. Kept across variant changes.
    var galIndex = 0;
    if (thumbs && mainImg && mainShot) {
      var galButtons = function () {
        return [].slice.call(thumbs.querySelectorAll("button"));
      };
      // Highlight image i in place, swap the hero, and scroll it into view. Loops
      // past the ends so next/prev never dead-end.
      var setActive = function (i, scroll) {
        var btns = galButtons();
        if (!btns.length) return;
        galIndex = (i + btns.length) % btns.length;
        btns.forEach(function (b, n) {
          b.classList.toggle("on", n === galIndex);
        });
        var src = btns[galIndex].getAttribute("data-img");
        if (src) {
          setMainImage(src);
        } else {
          mainShot.classList.remove("imgfail");
        }
        // A fast clicker can overtake the idle queue — warm both neighbours now.
        var n = btns.length;
        if (n > 1) {
          warmUrl(btns[(galIndex + 1) % n].getAttribute("data-img"), "auto");
          warmUrl(btns[(galIndex - 1 + n) % n].getAttribute("data-img"), "auto");
        }
        if (scroll) {
          btns[galIndex].scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "nearest",
          });
        }
      };

      // Click a thumbnail → make it the active image (the highlight moves to it).
      thumbs.addEventListener("click", function (e) {
        var b = e.target.closest("button");
        if (!b) return;
        setActive(galButtons().indexOf(b), true);
      });

      // Hover / focus on a thumbnail warms its hero before the click lands — same
      // intent rule as the swatches below. Delegated, so it survives applyGallery.
      var warmThumbIntent = function (e) {
        var b = e.target.closest && e.target.closest("button");
        if (b) warmUrl(b.getAttribute("data-img"), "auto");
      };
      thumbs.addEventListener("pointerover", warmThumbIntent);
      thumbs.addEventListener("focusin", warmThumbIntent);

      // Hero ‹ › arrows step the selection right/left through all images (looping).
      var galPrev = scope.querySelector("#galPrev");
      var galNext = scope.querySelector("#galNext");
      if (galPrev) {
        galPrev.addEventListener("click", function () {
          setActive(galIndex - 1, true);
        });
      }
      if (galNext) {
        galNext.addEventListener("click", function () {
          setActive(galIndex + 1, true);
        });
      }

      // Thumbnail carousel arrows page the strip left/right (Folio-style). They only
      // show when the strip overflows, and disable at each end.
      var thumbrail = scope.querySelector("[data-thumbrail]");
      var thumbPrev = scope.querySelector("#thumbPrev");
      var thumbNext = scope.querySelector("#thumbNext");
      if (thumbrail) {
        syncThumbNav = function () {
          var max = thumbs.scrollWidth - thumbs.clientWidth;
          var scrollable = max > 1;
          thumbrail.classList.toggle("is-scrollable", scrollable);
          if (!scrollable) return;
          var x = thumbs.scrollLeft;
          if (thumbPrev) thumbPrev.disabled = x <= 1;
          if (thumbNext) thumbNext.disabled = x >= max - 1;
        };
        var pageThumbs = function (dir) {
          thumbs.scrollBy({
            left: dir * thumbs.clientWidth * 0.8,
            behavior: "smooth",
          });
        };
        if (thumbPrev) {
          thumbPrev.addEventListener("click", function () {
            pageThumbs(-1);
          });
        }
        if (thumbNext) {
          thumbNext.addEventListener("click", function () {
            pageThumbs(1);
          });
        }
        thumbs.addEventListener("scroll", syncThumbNav, { passive: true });
        window.addEventListener("resize", syncThumbNav);
        syncThumbNav();
      }
      prewarmThumbs();
    }

    // Variant resolution — data-driven from product.variants.
    var sws = scope.querySelector("#sws");
    var priceEl = scope.querySelector("#price");
    var poaNoteEl = scope.querySelector("[data-poa-note]");
    var priceNoteEl = scope.querySelector("[data-price-note]");
    var smpNoteEl = scope.querySelector("[data-smp-note]");

    // The notes under the figure must follow the variant, not just the figure
    // itself: a POA colourway kept "excl. VAT · installed" and "*SMP" from
    // whichever priced colourway happened to render first.
    var setPriceNotes = function (isPoa) {
      if (poaNoteEl) poaNoteEl.hidden = !isPoa;
      if (priceNoteEl) priceNoteEl.hidden = !!isPoa;
      if (smpNoteEl) smpNoteEl.hidden = !!isPoa;
    };
    var quoteBtn = scope.querySelector("[data-quote-add]");
    var stockCell = scope.querySelector("#pmStock");

    var setStock = function (available) {
      if (!stockCell) return;
      var lbl = available
        ? stockCell.getAttribute("data-in-label")
        : stockCell.getAttribute("data-out-label");
      var cap = available
        ? stockCell.getAttribute("data-in-caption")
        : stockCell.getAttribute("data-out-caption");
      stockCell.textContent = "";
      var b = document.createElement("b");
      b.textContent = lbl || "";
      stockCell.appendChild(b);
      stockCell.appendChild(document.createTextNode(cap || ""));
      stockCell.classList.toggle("is-out", !available);
    };

    // The "Spec sheet (PDF)" button is handled by assets/spec-sheet.js (QUELL-115).

    var variants = [];
    try {
      var vjson = scope.querySelector("[data-pm-variants]");
      if (vjson) {
        variants = JSON.parse(vjson.textContent);
      }
    } catch (err) {
      variants = [];
    }
    var highVariantProduct = variants.length >= 250;

    var optionControls = [].slice.call(
      scope.querySelectorAll("[data-option-position]"),
    );

    var currentSelection = function () {
      var sel = {};
      optionControls.forEach(function (c) {
        if (c.classList.contains("on")) {
          sel[c.getAttribute("data-option-position")] =
            c.getAttribute("data-value");
        }
      });
      return sel;
    };

    var currentOptionValueIds = function () {
      var idsByPosition = {};
      optionControls.forEach(function (c) {
        if (!c.classList.contains("on")) return;
        var pos = c.getAttribute("data-option-position");
        var id = c.getAttribute("data-option-value-id");
        if (pos && id) idsByPosition[pos] = id;
      });
      return Object.keys(idsByPosition)
        .sort(function (a, b) {
          return Number(a) - Number(b);
        })
        .map(function (pos) {
          return idsByPosition[pos];
        });
    };

    // Quote spec: join the selected option values, dropping raw hex colour
    // codes. Internal Colour option values are stored as hex (e.g. "#615f5d"),
    // which must never surface in the customer-facing quote. QUELL-194.
    var HEX_RE = /^#[0-9a-f]{3,8}$/i;
    var specString = function (sel) {
      return Object.keys(sel)
        .sort()
        .map(function (k) {
          return sel[k];
        })
        .filter(function (v) {
          return v && !HEX_RE.test(v.trim());
        })
        .join(" · ");
    };

    var findVariant = function (sel) {
      var positions = Object.keys(sel);
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (
          positions.every(function (pos) {
            return v.options[pos - 1] === sel[pos];
          })
        ) {
          return v;
        }
      }
      return null;
    };

    // Variant gallery (QUELL-99): per-swatch templates only cover the colour
    // groups (External/Internal). When the resolved variant differs — Furniture
    // changed, or a colour combined with a non-default furniture — fetch that
    // variant's images via the Section Rendering API so the gallery matches the
    // variant, the way OMNI does. Reuses sections/product-variant-gallery.liquid.
    var productUrl =
      (quoteBtn && quoteBtn.getAttribute("data-url")) || location.pathname;
    var lastGalleryVid = quoteBtn ? quoteBtn.getAttribute("data-key") : null;
    var galleryAbort = null;
    var galleryCache = {};
    var galleryReq = 0;

    // Swap thumbs + hero on variant change, keeping the gallery position.
    var applyGallery = function (html) {
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, "text/html");
      var tEl = doc.querySelector("[data-vg-thumbs]");
      if (!tEl) return;
      var resolvedVid = tEl.getAttribute("data-variant-id");
      var resolvedPrice = tEl.getAttribute("data-variant-price");
      var resolvedAvailable = tEl.getAttribute("data-variant-available");
      var resolvedPoa = tEl.getAttribute("data-variant-poa");
      if (resolvedVid) {
        scope.dataset.specVariant = String(resolvedVid);
        lastGalleryVid = String(resolvedVid);
        if (quoteBtn) quoteBtn.setAttribute("data-key", resolvedVid);
      }
      if (resolvedPrice) {
        if (priceEl) priceEl.textContent = resolvedPrice;
        if (quoteBtn) quoteBtn.setAttribute("data-price", resolvedPrice);
      }
      if (resolvedPoa) setPriceNotes(resolvedPoa === "true");
      if (resolvedAvailable) {
        var isAvailable = resolvedAvailable === "true";
        var isPoa = resolvedPoa === "true";
        if (quoteBtn) quoteBtn.classList.toggle("is-unavailable", !isAvailable && !isPoa);
        setStock(isAvailable);
      }
      var newBtns = tEl.querySelectorAll("button");
      var keep = Math.max(0, Math.min(galIndex, newBtns.length - 1));
      // Hero first: paint the main image before swapping the strip below. Always
      // call setMainImage so an empty heroUrl swaps the hero back to the empty
      // placeholder rather than leaving the previous variant's <img> on screen.
      var heroBtn = newBtns[keep];
      var heroUrl = heroBtn ? heroBtn.getAttribute("data-img") : "";
      setMainImage(heroUrl || "", true);
      if (thumbs) {
        var prevScroll = thumbs.scrollLeft;
        thumbs.innerHTML = tEl.innerHTML;
        galIndex = keep;
        // Fetched HTML marks the first thumb .on — move it to the kept index.
        [].forEach.call(thumbs.querySelectorAll("button"), function (b, n) {
          b.classList.toggle("on", n === keep);
        });
        thumbs.scrollLeft = prevScroll; // browser clamps if shorter
        syncThumbNav();
        prewarmThumbs();
      }
    };

    var fetchVariantGallery = function (vid) {
      if (!vid || !productUrl) return;
      // Cancel any in-flight fetch and claim this as the latest request FIRST, so a
      // slower earlier response — or a cache hit racing an in-flight fetch — can never
      // override the current variant's gallery (was leaving the hero on the old image).
      if (galleryAbort) galleryAbort.abort();
      var req = ++galleryReq;
      // Re-show an already-fetched variant instantly (no network round-trip).
      // With warmAllVariants below this is the branch that runs on every click.
      if (galleryCache[vid]) {
        applyGallery(galleryCache[vid]);
        return;
      }
      galleryAbort =
        typeof AbortController === "function" ? new AbortController() : null;
      var sep = productUrl.indexOf("?") === -1 ? "?" : "&";
      var url =
        productUrl +
        sep +
        "section_id=product-variant-gallery&variant=" +
        encodeURIComponent(vid);
      fetch(url, galleryAbort ? { signal: galleryAbort.signal } : undefined)
        .then(function (r) {
          return r.ok ? r.text() : null;
        })
        .then(function (html) {
          if (req !== galleryReq) return; // a newer selection superseded this response
          if (html) {
            galleryCache[vid] = html;
            applyGallery(html);
          }
        })
        .catch(function () {});
    };

    var fetchSelectedGallery = function () {
      if (!productUrl) return;
      var ids = currentOptionValueIds();
      if (!ids.length) return;
      var cacheKey = "ov:" + ids.join(",");
      if (galleryAbort) galleryAbort.abort();
      var req = ++galleryReq;
      if (galleryCache[cacheKey]) {
        applyGallery(galleryCache[cacheKey]);
        return;
      }
      galleryAbort =
        typeof AbortController === "function" ? new AbortController() : null;
      var sep = productUrl.indexOf("?") === -1 ? "?" : "&";
      var url =
        productUrl +
        sep +
        "section_id=product-variant-gallery&option_values=" +
        encodeURIComponent(ids.join(","));
      fetch(url, galleryAbort ? { signal: galleryAbort.signal } : undefined)
        .then(function (r) {
          return r.ok ? r.text() : null;
        })
        .then(function (html) {
          if (req !== galleryReq) return;
          if (html) {
            galleryCache[cacheKey] = html;
            applyGallery(html);
          }
        })
        .catch(function () {});
    };

    // Proxy cache warming (perf): the cut-out CDN transforms images on demand, so
    // the FIRST view of a variant's hero pays a cold ~2s transform while a warm one
    // is ~0.3s — this is the "slow first time, fast on return" the gallery showed.
    // prefetchGallery quietly fetches a variant's gallery section (memoised in
    // galleryCache, so the click needs no round-trip) and warms its hero image at
    // low priority, so the swatch the user is about to pick lands on a warm cache.
    // Independent of fetchVariantGallery's abort/apply path — it never touches the
    // visible gallery, and dedupes so each variant is warmed at most once.
    var prefetchInFlight = {};
    var prefetchGallery = function (vid) {
      if (!vid || !productUrl) return;
      vid = String(vid);
      if (galleryCache[vid] || prefetchInFlight[vid]) return;
      prefetchInFlight[vid] = true;
      var sep = productUrl.indexOf("?") === -1 ? "?" : "&";
      var url =
        productUrl +
        sep +
        "section_id=product-variant-gallery&variant=" +
        encodeURIComponent(vid);
      fetch(url)
        .then(function (r) {
          return r.ok ? r.text() : null;
        })
        .then(function (html) {
          if (!html) return;
          galleryCache[vid] = html;
          var doc = new DOMParser().parseFromString(html, "text/html");
          var firstThumb = doc.querySelector(
            "[data-vg-thumbs] button[data-img]",
          );
          var heroUrl = firstThumb && firstThumb.getAttribute("data-img");
          warmUrl(heroUrl, "low");
        })
        .catch(function () {});
    };

    var swBtns = [].slice.call(scope.querySelectorAll(".sw-btn"));
    // Never hide a swatch — an orderable colourway stays visible. It is faded
    // when the EXACT combo it would select has no photos of its own, or isn't
    // a real variant at all. Both depend on the other axes currently selected,
    // so this re-resolves on every selection change, and it reads the same
    // per-variant hasImg the price uses for POA — so a faded swatch and an
    // "Enquire" price always agree. Mirrors snippets/pm-swatch.liquid.
    var resolveSwatchVisibility = function (sel) {
      if (highVariantProduct) return;
      if (!swBtns.length || !variants.length) return;
      swBtns.forEach(function (b) {
        var pos = b.getAttribute("data-option-position");
        if (!pos) return;
        var hypo = {};
        for (var k in sel) {
          if (Object.prototype.hasOwnProperty.call(sel, k)) hypo[k] = sel[k];
        }
        hypo[pos] = b.getAttribute("data-value");
        var v = findVariant(hypo);

        var unavailable = !v || !v.hasImg;
        b.hidden = unavailable && !b.classList.contains("on");
        b.classList.toggle("is-unavailable", unavailable);
        b.setAttribute("aria-disabled", unavailable ? "true" : "false");
      });
    };

    var resolve = function () {
      var sel = currentSelection();
      resolveSwatchVisibility(sel);
      var match = findVariant(sel);
      if (match) {
        scope.dataset.specVariant = String(match.id);
        if (priceEl && match.price) {
          priceEl.textContent = match.price;
        }
        setPriceNotes(!!match.poa);
        var subEl = scope.querySelector(".subtitle");
        if (subEl && match.subtitle) {
          subEl.textContent = match.subtitle;
        }
        if (quoteBtn) {
          quoteBtn.setAttribute("data-key", match.id);
          if (match.price) {
            quoteBtn.setAttribute("data-price", match.price);
          }
          quoteBtn.setAttribute("data-spec", specString(sel));
          quoteBtn.classList.toggle("is-unavailable", !match.available && !match.poa);
        }
        setStock(!!match.available);
        if (String(match.id) !== String(lastGalleryVid)) {
          lastGalleryVid = String(match.id);
          fetchVariantGallery(match.id);
        }
      } else {
        if (highVariantProduct) {
          if (quoteBtn) quoteBtn.setAttribute("data-spec", specString(sel));
          fetchSelectedGallery();
        } else {
          if (quoteBtn) {
            quoteBtn.classList.add("is-unavailable");
          }
          if (variants.length) {
            setStock(false);
          }
        }
      }
    };

    // Colour swatches (External + Internal): update selection + label, then
    // resolve() re-renders the gallery for the resolved variant via AJAX — the
    // SAME single path Furniture uses, so every option behaves identically and
    // the hero/thumbs/slides can never drift apart.
    if (sws) {
      var selectColour = function (b, pushUrl) {
        // Scope selection + label to the swatch's own group (External / Internal).
        var grp = b.closest(".sws") || sws;
        grp.querySelectorAll(".sw-btn").forEach(function (x) {
          x.classList.remove("on");
        });
        b.classList.add("on");
        var grpOpt = b.closest(".opt");
        var grpLabel = grpOpt && grpOpt.querySelector(".val");
        if (grpLabel) {
          grpLabel.textContent = b.getAttribute("data-name");
        }

        var thumb = b.getAttribute("data-thumb");
        if (thumb && quoteBtn) {
          quoteBtn.setAttribute("data-image", thumb);
        }

        resolve();

        if (pushUrl) {
          var key = quoteBtn && quoteBtn.getAttribute("data-key");
          if (key) {
            try {
              history.replaceState(
                {},
                "",
                location.pathname + "?variant=" + key,
              );
            } catch (err) {}
          }
        }
      };

      // Bind every swatch group (External + Internal Colour).
      scope.querySelectorAll(".sws").forEach(function (g) {
        g.addEventListener("click", function (e) {
          var b = e.target.closest(".sw-btn");
          if (!b) return;
          selectColour(b, true);
        });
      });

      // Finish toggle (Powder-coated / Upholstered): filters the External Colour
      // swatches by hex group. The toggle is not a Shopify option, so it never
      // participates in variant resolution — it only shows/hides .sw-btn.
      var finishToggle = scope.querySelector("#finishToggle");
      if (finishToggle) {
        var applyFinish = function (finish, autoselect) {
          finishToggle.querySelectorAll(".finish-tab").forEach(function (t) {
            t.classList.toggle(
              "on",
              t.getAttribute("data-finish-tab") === finish,
            );
          });
          var firstVisible = null;
          sws.querySelectorAll(".sw-btn").forEach(function (b) {
            var f = b.getAttribute("data-finish");
            var match = !f || f === finish;
            b.classList.toggle("is-hidden", !match);
            if (match && !firstVisible) firstVisible = b;
          });
          // If the selected swatch belongs to the other finish, move to the
          // first swatch of the chosen finish so the gallery/variant updates.
          if (autoselect) {
            var on = sws.querySelector(".sw-btn.on");
            if ((!on || on.classList.contains("is-hidden")) && firstVisible) {
              selectColour(firstVisible, true);
            }
          }
        };
        finishToggle.addEventListener("click", function (e) {
          var t = e.target.closest(".finish-tab");
          if (!t) return;
          applyFinish(t.getAttribute("data-finish-tab"), true);
        });
        var initTab = finishToggle.querySelector(".finish-tab.on");
        if (initTab) {
          applyFinish(initTab.getAttribute("data-finish-tab"), false);
        }
      }
    }

    // Non-colour option pills: select within the group, then resolve.
    scope.querySelectorAll(".segs").forEach(function (group) {
      group.addEventListener("click", function (e) {
        var b = e.target.closest(".seg");
        if (!b) return;
        group.querySelectorAll(".seg").forEach(function (x) {
          x.classList.remove("on");
        });
        b.classList.add("on");
        resolve();
      });
    });

    // Hover / focus intent: warm a variant's gallery the moment the user shows
    // interest in its swatch or pill, so the click lands on a warm proxy cache
    // (~0.3s) instead of a cold transform (~2s). Only warms what's actually
    // hovered/focused — no blanket background download of every variant. Resolve
    // the variant a single option-change would select, then prefetch it.
    var prefetchForControl = function (ctrl) {
      if (!ctrl) return;
      var pos = ctrl.getAttribute("data-option-position");
      if (!pos) return;
      var sel = currentSelection();
      sel[pos] = ctrl.getAttribute("data-value");
      var m = findVariant(sel);
      if (m) prefetchGallery(m.id);
    };
    var onIntent = function (e) {
      var ctrl = e.target.closest && e.target.closest("[data-option-position]");
      if (ctrl) prefetchForControl(ctrl);
    };
    scope.addEventListener("pointerover", onIntent);
    scope.addEventListener("focusin", onIntent);

    // Warm every variant's gallery upfront so the swatch click is instant —
    // no spinner, no wait. The hero-prewarm path above (prewarmThumbs) holds
    // the strip warm for the current variant; this holds the section HTML +
    // first hero of every OTHER variant, so applyGallery hits the cache on
    // every click. Staggered so an eight-variant chair is not a burst.
    var warmAllVariants = function () {
      if (!variants || !variants.length || highVariantProduct) return;
      var stride = 0;
      var tick = function () {
        if (stride >= variants.length) return;
        var v = variants[stride++];
        if (v && v.id) prefetchGallery(v.id);
        setTimeout(tick, 180);
      };
      var schedule = function () {
        if ("requestIdleCallback" in window)
          requestIdleCallback(tick, { timeout: 1500 });
        else setTimeout(tick, 400);
      };
      // Hold until the visible hero has painted — same rule as prewarmThumbs.
      if (mainImg && !mainImg.complete) {
        mainImg.addEventListener("load", schedule, { once: true });
        mainImg.addEventListener("error", schedule, { once: true });
      } else {
        schedule();
      }
    };
    warmAllVariants();

    // Sync price / variant id / availability with the initial selection.
    resolve();

    // About: read-more clamp (shows the toggle only when the text overflows).
    (function () {
      var wrap = scope.querySelector("#pmAbout"),
        text = scope.querySelector("#pmAboutText"),
        btn = scope.querySelector("#pmAboutMore");
      if (!wrap || !text || !btn) return;
      var check = function () {
        if (wrap.classList.contains("open")) return;
        btn.classList.toggle("show", text.scrollHeight - text.clientHeight > 4);
      };
      btn.addEventListener("click", function () {
        var open = wrap.classList.toggle("open");
        text.classList.toggle("clamped", !open);
        btn.setAttribute("aria-expanded", open ? "true" : "false");
        btn.firstChild.textContent =
          (open
            ? btn.dataset.less || "Read less"
            : btn.dataset.more || "Read more") + " ";
        if (!open) {
          requestAnimationFrame(check);
        }
      });
      requestAnimationFrame(check);
      window.addEventListener("resize", check);
    })();
  }

  /* bottom quote CTA: eased scroll to hero (desktop) / buybar (mobile), then pulse */
  var pulseWatch = 0;
  var qEase = function (p) {
    return p < 0.5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2;
  };
  document.addEventListener("click", function (e) {
    if (!e.target.closest("[data-quote-scroll]")) return;
    var hero = document.getElementById("pdp-top");
    var btn = hero && hero.querySelector(".buybar .btn");
    if (!btn) return;
    e.preventDefault();
    var token = ++pulseWatch;

    var mobile = window.matchMedia("(max-width: 940px)").matches;
    var rect = (mobile ? btn : hero).getBoundingClientRect();
    var target = mobile
      ? rect.top + window.scrollY - (window.innerHeight - rect.height) / 2
      : rect.top + window.scrollY - 90; // matches #pdp-top scroll-margin-top
    target = Math.max(0, Math.round(target));

    var root = document.documentElement;
    var finish = function () {
      root.classList.remove("quote-scrolling");
      root.style.scrollBehavior = "";
    };
    root.style.scrollBehavior = "auto"; // CSS smooth would fight the tween

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      window.scrollTo(0, target);
      finish();
    } else {
      var startY = window.scrollY;
      var dist = target - startY;
      var dur = Math.min(1200, Math.max(600, Math.abs(dist) / 8));
      var t0;
      var stopped = false;
      var stop = function () {
        stopped = true;
      };
      window.addEventListener("wheel", stop, { passive: true, once: true });
      window.addEventListener("touchstart", stop, {
        passive: true,
        once: true,
      });
      root.classList.add("quote-scrolling");
      var step = function (ts) {
        if (stopped || token !== pulseWatch) return finish();
        if (t0 === undefined) t0 = ts;
        var p = Math.min(1, (ts - t0) / dur);
        window.scrollTo(0, startY + dist * qEase(p));
        if (p < 1) requestAnimationFrame(step);
        else finish();
      };
      requestAnimationFrame(step);
    }
    var last = window.scrollY,
      same = 0,
      frames = 0;
    var tick = function () {
      if (token !== pulseWatch) return;
      same = Math.abs(window.scrollY - last) < 1 ? same + 1 : 0;
      last = window.scrollY;
      // ~10 still frames = scroll settled; 300 frames (~5s) is the failsafe
      if (same >= 10 || ++frames > 300) {
        btn.classList.remove("qpulse");
        void btn.offsetWidth; // restart the animation on repeat clicks
        btn.classList.add("qpulse");
        btn.addEventListener(
          "animationend",
          function () {
            btn.classList.remove("qpulse");
          },
          { once: true },
        );
        return;
      }
      requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  });

  ready(function () {
    document.querySelectorAll("[data-product-main]").forEach(function (el) {
      initProductMain(el.closest(".shopify-section") || el);
    });
  });
  document.addEventListener("shopify:section:load", function (e) {
    if (
      e.target.querySelector &&
      e.target.querySelector("[data-product-main]")
    ) {
      initProductMain(e.target);
    }
  });
})();
